import React from 'react';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import '../Steps.scss';
import { StepProps, steps } from '../Steps';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { SET_TOUR } from '@mm/state/modules/modalsState/actions';
import { StoreState } from '@mm/state/store-interfaces';
import { trackWebAppGAEvent } from '../../../../common/helpers/plugins/website-google-analytics';

export const StepControls = (props: StepProps) => {
  const { step, goTo, close } = props;
  const dispatch: Dispatch<StoreState> = useDispatch();
  const onClose = () => {
    trackWebAppGAEvent('click', {
      category: 'modal',
      label: `ui_tour_controls_end_button`,
    });
    close();
    dispatch({
      type: SET_TOUR,
      payload: false,
    });
  };
  return (
    <div className="step-controls">
      {step !== 1 ? (
        <PrimaryButton
          className="step-controls__button"
          onClick={() => goTo(step - 2)}
          color={ButtonColor.secondaryBlue}
        >
          Back
        </PrimaryButton>
      ) : (
        <div />
      )}
      {step !== steps.length && (
        <PrimaryButton
          className="step-controls__button"
          onClick={() => goTo(step)}
        >
          Next
        </PrimaryButton>
      )}
      {step === steps.length && (
        <PrimaryButton
          className="step-controls__button step-controls__button-end-tour"
          onClick={onClose}
        >
          End Tour
        </PrimaryButton>
      )}
    </div>
  );
};
